import Base from "./base";

export default class FxCuzdan extends Base {
    makeExternalPayment(newStep, bonusId) {
        const { iban, stake } = this.state;
        this.props.externalFunc.makeDeposit({
            amount: stake
        }, (data) => {
            this.setState({
                externalUrl: data.payment_url,
                currentStep: newStep
            })
        });
    }

    makeExternalPaymentWithBonus(newStep, bonusId) {
        const { iban, stake } = this.state;
        this.props.externalFunc.makeDeposit({
            amount: stake,
            claimsBonus: true,
            bonusId: bonusId
        }, (data) => {
            this.setState({
                externalUrl: data.payment_url,
                currentStep: newStep
            })
        });
    }
}
